var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 46 45"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 22.5,
  r: 22.5,
  fill: "#3DB460"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.171,
  d: "M33.119 21.286h-9.31V12.38a.81.81 0 1 0-1.619 0v8.905h-9.31a.81.81 0 1 0 0 1.619h9.31v9.714a.81.81 0 1 0 1.62 0v-9.714h9.309a.81.81 0 1 0 0-1.62Z"
})));
export default SvgPlus;